import { Injectable } from '@angular/core';
import { JwtAuthService } from './auth/jwt-auth.service';
import { environment } from '../../../environments/environment';
import * as amplitude from '@amplitude/analytics-browser';
import { pageUrlEnrichmentPlugin } from '@amplitude/plugin-page-url-enrichment-browser';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {
  amplitude: any = amplitude;
  identifyEvent: any;

  constructor(private jwtAuthService: JwtAuthService) {
    this.amplitude = amplitude;
    this.identifyEvent = new this.amplitude.Identify();
  }

  get getAmplitude() {
    return this.amplitude;
  }

  init(userId: any) {
    const user = this.jwtAuthService.getUser();
    userId = userId ?? user?.id;
    if (userId) {
      userId = userId.toString();
      for (let i = 0; i < (5 - userId.length); i++) {
        userId = '0' + userId;
      }
    }

    const config = {
      sessionTimeout: 30 * 60 * 1000,  // 30 min
      logLevel: amplitude.Types.LogLevel.None,
      autocapture: { formInteractions: false, elementInteractions: true, pageViews: true },
    };

    this.amplitude?.init(environment.amplitude, userId || null, config);
    // 1. Adiciona o plugin oficial (ele vai capturar a URL suja do browser)
    this.amplitude.add(pageUrlEnrichmentPlugin());

    // 2. Adiciona o SEU plugin de limpeza (ele vai "limpar" o que o plugin oficial capturou)
    // Como ele é adicionado por último, ele tem a palavra final no evento
    this.amplitude.add(this.createUrlNormalizerPlugin());
  }

  private createUrlNormalizerPlugin() {
    return {
      name: 'url-normalizer',
      type: 'enrichment',
      execute: async (event: any) => {
        // Lista de campos que o Amplitude usa para URL
        const urlProps = [
          'page_path',
          'page_location',
          '[Amplitude] Page Path',
          '[Amplitude] Page Location',
          '[Amplitude] Page URL',
          '[Amplitude] Previous Page Location'
        ];

        if (event.event_properties) {
          urlProps.forEach(prop => {
            if (event.event_properties[prop]) {
              event.event_properties[prop] = this.normalizePath(event.event_properties[prop]);
            }
          });
        }
        return event;
      },
    };
  }

  private normalizePath(path: string): string {
    if (!path) return path;
    // Regex para mascarar o ID da organização
    return path.replace(/\/organizacoes\/[^\/]+/, '/organizacoes/:orgId');
  }


  addIdentifyEventArray(index: EventIdentifyAmplitude, value: any) {
    this.identifyEvent.set(index, value);
  }

  addIdentifyEvent(index: EventIdentifyAmplitude, value: any) {
    this.identifyEvent.set(index, value?.toString());
  }

  setUserId(id: string) {
    let userId = id;
    for (let i = 0; i < (5 - userId.length); i++) {
      userId = '0' + userId;
    }
    this.amplitude.setUserId(userId);
  }

  setIdentify() {
    this.amplitude.identify(this.identifyEvent);
  }

  sendEvent(eventName: EventNameAmplitude, props?: Record<string, any>) {
    this.amplitude.track(
      eventName,
      props
    );
  }
}

type EventIdentifyAmplitude =
  'permission_org_type' |
  'permission_org_id' |
  'permission_org_name' |
  'user_id' |
  'user_type' |
  'age' |
  'biological_sex'


type EventNameAmplitude =
  'org_context_selected' |
  'search_user_performed' |
  'web_crypto_support' |
  'patients_documents_downloaded' |
  'patients_detailed_info_menu_opened' |
  'new_contact_registered' |
  'status_list_downloaded' |
  'cell_phone_code_validated' |
  'manager_registered' |
  'cell_phone_is_valid' |
  'validation_failed' |
  'contact_support_clicked';
